export default "__VITE_ASSET__BjkObpOq__"